[
    {
        "id": "seed_cb_001",
        "question": "O mercado interbancário é um segmento muito importante do sistema financeiro, onde instituições bancárias realizam operações entre si, tendo como instrumento o Certificado de Depósito Interbancário (CDI), que consiste em um sistema de empréstimo de curtíssimo prazo entre as instituições financeiras com necessidade de liquidez.\n\nAs taxas de juros no mercado interbancário são determinadas pela",
        "options": [
            "Resolução do Conselho Monetário Nacional (CMN), que indica o limite máximo de volatilidade diária das operações compromissadas em Títulos Públicos Estaduais.",
            "variação diária dos títulos pós-fixados ou indexados a taxas de inflação negociados pelo Tesouro Nacional com o mercado, através do Tesouro Direto.",
            "oferta e demanda de recursos entre as instituições financeiras participantes, sendo a taxa de Depósito Interbancário (DI) apurada pela Central de Custódia e Liquidação Financeira de Títulos Privados (Cetip), que integra a B3.",
            "variação diária da taxa referencial (TR), calculada e divulgada mensalmente pelo Conselho Monetário Nacional (CMN).",
            "variação do IPCA mais uma taxa fixa, determinada pela variação da Letra Financeira do Tesouro Nacional (LFT)."
        ],
        "correctIndex": 2,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Científico",
        "assunto": "Noções de Mercado de Capitais"
    },
    {
        "id": "seed_cb_002",
        "question": "Um executivo com experiência no setor de varejo foi contratado para dirigir um banco. Durante o período de transição da equipe da antiga direção para a nova, ele ordenou que sua equipe analisasse os componentes do capital intelectual da organização. Ao final desse período, sua equipe deu grande destaque aos aspectos ligados ao capital relacional.\n\nEsse destaque diz respeito",
        "options": [
            "à quantidade de conhecimento e de competências dos funcionários do banco.",
            "às diversas oportunidades de ganhos, com investimentos financeiros para o próprio banco.",
            "ao grande número de marcas e patentes registradas anteriormente pelo banco.",
            "ao conhecimento gerado a partir das associações com clientes e com fornecedores do banco.",
            "aos sistemas de gestão desenvolvidos pelos funcionários e pelos diretores do banco."
        ],
        "correctIndex": 3,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Científico",
        "assunto": "Aprendizagem Organizacional"
    },
    {
        "id": "seed_cb_003",
        "question": "De acordo com o Banco Central do Brasil, que regulamenta o mercado de câmbio e de capitais estrangeiros no país, nos contratos de câmbio, é suscetível de alteração o(a)",
        "options": [
            "comprador",
            "vendedor",
            "prazo para a sua liquidação",
            "código da moeda estrangeira",
            "taxa de câmbio"
        ],
        "correctIndex": 2,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Bancário",
        "assunto": "Noções de Mercado de Câmbio"
    },
    {
        "id": "seed_cb_004",
        "question": "Um dos maiores desafios da política fiscal é manter a razão entre a dívida bruta do setor público e o PIB (em termos simples, a razão dívida pública/PIB) em níveis baixos e estáveis no longo prazo.\n\nConsiderando-se que todos os demais fatores permaneçam constantes, contribui para a redução da razão dívida pública/PIB o seguinte fator:",
        "options": [
            "déficits fiscais primários crescentes",
            "menores taxas de crescimento econômico",
            "menor arrecadação tributária, por parte da União",
            "redução da taxa básica de juros de curto prazo (Selic)",
            "aumento dos gastos do governo"
        ],
        "correctIndex": 3,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Bancário",
        "assunto": "Política Fiscal"
    },
    {
        "id": "seed_cb_005",
        "question": "Uma desvalorização real da moeda brasileira (o Real) em relação ao Dólar acarreta o(a)",
        "options": [
            "barateamento, em Dólar, dos produtos fabricados no Brasil e que competem com produtos importados similares.",
            "barateamento, em Dólar, das viagens turísticas dos brasileiros ao exterior.",
            "barateamento, em Dólar, dos produtos importados brasileiros.",
            "encarecimento, em Dólar, dos produtos exportados brasileiros.",
            "redução da rentabilidade, em Reais, dos exportadores brasileiros."
        ],
        "correctIndex": 0,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Caixa",
        "cargo": "Técnico Bancário",
        "assunto": "Noções de Mercado de Câmbio"
    },
    {
        "id": "seed_cb_006",
        "question": "Um cliente estava procurando investir e identificou um investimento com as seguintes características: a captação de recursos é feita por meio do sistema de distribuição de valores mobiliários; as classes de cotas são constituídas em regime fechado e têm prazo de duração indeterminado; a participação da classe de cotas em empreendimentos imobiliários se dá por meio da aquisição dos ativos como cotas de outros fundos de investimentos imobiliários, letras hipotecárias e letras de crédito imobiliário; e os recursos captados no país não são aplicados no exterior.\n\nConsiderando-se as informações apresentadas, o investimento analisado pelo cliente se enquadra como um(a)",
        "options": [
            "Ação",
            "Poupança",
            "Debênture",
            "Fundo de Investimento Imobiliário",
            "Certificado de Depósito Bancário (CDB)"
        ],
        "correctIndex": 3,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Caixa",
        "cargo": "Técnico Bancário",
        "assunto": "Noções de Mercado de Capitais"
    },
    {
        "id": "seed_at_001",
        "question": "Uma instituição financeira precisa adquirir uma plataforma computacional que trabalhe com a ideia de Ciência de Dados, a fim de auxiliar tomadas de decisões pelos gerentes dessa instituição.\n\nPara a devida escolha, essa plataforma deve caracterizar-se por",
        "options": [
            "ser capaz de conectar-se a um conjunto de equipamentos, dispositivos e softwares para gerenciar o comportamento de outras máquinas ou sistemas físicos, com uso de modelagem matemática.",
            "atuar como um concentrador central para comunicação dentro da empresa, gerenciando o fluxo de mensagens, além de providenciar que qualquer mensagem seja encaminhada à rota mais segura.",
            "ser responsável por aceitar requisições de clientes, usando interfaces próprias e apresentando as respostas dessas requisições em um formato de páginas construídas por uma linguagem de marcação, contendo mídias diferentes.",
            "auxiliar no armazenamento de arquivos de formatos variados, facilitando a alocação desses arquivos em áreas livres da memória auxiliar, cuidando para que cada unidade de alocação fique próxima uma da outra e ajude na busca dos mesmos.",
            "escalar com os negócios da empresa à medida que a equipe da mesma cresça, estando sempre altamente disponível, possuindo controles de acesso robustos e suportando um grande número de usuários simultâneos."
        ],
        "correctIndex": 4,
        "category": "ATUALIDADES",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Caixa",
        "cargo": "Técnico Bancário",
        "assunto": "Transformação Digital no Sistema Financeiro"
    },
    {
        "id": "seed_cb_007",
        "question": "Ao acompanhar o desempenho de uma empresa, na qual o Sistema BNDES possui investimentos, um analista constata que a demanda pelos bens produzidos por essa empresa é muito elástica, com relação aos preços de suas concorrentes. Isso quer dizer que, quando as concorrentes reduzem seus preços, tudo mais constante, a demanda pelos bens produzidos pela empresa analisada",
        "options": [
            "aumenta significativamente.",
            "é estável, com relação às variações de preços das concorrentes.",
            "varia pouco, com relação às reduções de preços das concorrentes.",
            "se acomoda rapidamente, mantendo a parcela de mercado da empresa.",
            "diminui mais do que proporcionalmente à redução de preços das concorrentes."
        ],
        "correctIndex": 4,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "BNDES",
        "cargo": "Analista - Engenharia Civil",
        "assunto": "Noções de Mercado de Capitais"
    },
    {
        "id": "seed_cb_008",
        "question": "Determinada instituição autorizada a funcionar pelo Banco Central do Brasil reúne sua diretoria para traçar políticas para cumprimento das normas bancárias, sem correr riscos de sanções legais.\n\nNos termos da Circular Bacen nº 3.978/2020, para assegurar os procedimentos e os controles internos de prevenção à lavagem de dinheiro, essa instituição deve dispor de estrutura de",
        "options": [
            "governança",
            "controle",
            "correição",
            "disciplina",
            "delação"
        ],
        "correctIndex": 0,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Bancário",
        "assunto": "Crime de Lavagem de Dinheiro"
    },
    {
        "id": "seed_cb_009",
        "question": "O cliente de um banco que deseje adquirir ações na bolsa de valores deve conhecer as características das operações envolvendo esses ativos.\n\nNa B3, bolsa de valores sediada em São Paulo, o prazo para a liquidação das operações no mercado à vista de ações é",
        "options": [
            "imediato, no momento da negociação",
            "imediato, após o registro da negociação",
            "até o fechamento do pregão no dia da negociação",
            "de 1 dia útil, a partir da data da negociação",
            "de 2 dias úteis, a partir da data da negociação"
        ],
        "correctIndex": 4,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Bancário",
        "assunto": "Noções de Mercado de Capitais"
    },
    {
        "id": "seed_cb_010",
        "question": "Em 23 de março de 2024, o Ministério da Fazenda publicou a seguinte notícia em sua página na internet:\n\nO presidente Luiz Inácio Lula da Silva assinou, na manhã desta terça-feira, o decreto que regulamenta a emissão das \"debêntures de infraestrutura\" e das \"debêntures incentivadas\", instituídas, respectivamente, pelas Leis nº 14.801/24 e nº 12.431/11. [...] O decreto das debêntures de infraestrutura tem como objetivo incentivar a execução de projetos essenciais para o país, sempre pautados em compromissos ambientais e sociais.\n\nAs debêntures são títulos emitidos",
        "options": [
            "pelo Governo Federal para o financiamento de grandes projetos de longo prazo.",
            "pelo Governo Federal, através dos quais ele repassa recursos para setores específicos da economia.",
            "por empresas que não possuem capital aberto e, portanto, não captam recursos na bolsa de valores.",
            "por empresas e que pagam bônus e dividendos aos seus detentores.",
            "por empresas, através dos quais elas podem captar recursos de maneira alternativa ao financiamento bancário."
        ],
        "correctIndex": 4,
        "category": "CONHECIMENTOS_BANCARIOS",
        "banca": "CESGRANRIO",
        "ano": 2024,
        "orgao": "Banco da Amazônia",
        "cargo": "Técnico Bancário",
        "assunto": "Noções de Mercado de Capitais"
    }
]